/** @jsx jsx */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { jsx } from "@emotion/core";
import RecommendationDashboard from "@mm/recommendation-dashboard";

const recommendationDashboardBucket =
  process.env.RECOMMENDATION_DASHBOARD_BUCKET;

const RecommendationsDashboard = ({ match }) => {
  const [dashboardData, setDashboardData] = useState({});
  const [loadingData, setLoadingData] = useState(true);

  const { dashboardTitle = [] } = dashboardData;

  const [{ title: dashboardTitleText } = {}] = dashboardTitle;

  const { params = {} } = match || {};
  const { dashboardId } = params;

  const filterOptions = [
    { key: "open", value: "open", text: "Open Recommendations" },
    { key: "closed", value: "closed", text: "Closed Recommendations" },
    { key: "all", value: "all", text: "Open & Closed Recommendations" }
  ];

  const getExternalChartingData = async id => {
    try {
      const requestUrl = `https://${recommendationDashboardBucket}.s3-us-west-2.amazonaws.com/${id}/current.json`;

      const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache"
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const externalData = await response.json();

      setDashboardData(externalData);
      setLoadingData(false);
    } catch (error) {
      console.error("Error fetching external dashboard data:", error);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getExternalChartingData(dashboardId);
  }, [dashboardId]);

  useEffect(() => {
    if (!loadingData && dashboardTitleText) {
      document.title = `${dashboardTitleText} - Missionmark`;
    } else if (!loadingData) {
      document.title = "Recommendations Dashboard - Missionmark";
    }
  }, [dashboardTitleText, loadingData]);

  return (
    <React.Fragment>
      <RecommendationDashboard
        data={dashboardData}
        loadingData={loadingData}
        filterOptions={filterOptions}
      />
    </React.Fragment>
  );
};

RecommendationsDashboard.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

RecommendationsDashboard.defaultProps = {
  match: {
    params: {}
  }
};

export default RecommendationsDashboard;
